import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    pageType: String,
    env: String,
    family: String,
    rmc: String,
  };

  connect() {
    let envName;

    switch (this.envValue) {
      case 'production':
        envName = 'prod';
        break;
      case 'staging':
        envName = 'dev';
        break;
      default:
        envName = null;
    }

    if (!envName) {
      window.digitalDataLayer = null;
      return;
    }

    const digitalDataLayer = {
      environment: {
        environmentName: envName,
      },
      page: {
        pageType: this.pageTypeValue,
      },
    };

    if (this.hasRmcValue && this.hasFamilyValue) {
      digitalDataLayer.products = {
        productFamily: this.familyValue,
        productRMC: this.rmcValue,
      };
      window.productModelPageRLX = `${this.familyValue};${this.rmcValue};`;
    } else {
      window.productModelPageRLX = null;
    }

    // Only update the data layer if it has changed
    if (JSON.stringify(digitalDataLayer) !== JSON.stringify(window.digitalDataLayer)) {
      window.digitalDataLayer = digitalDataLayer;
    }
  }
}
